<div class="d-flex dropdown-wrapper">
    <p-select [options]="foreignKeyOptions" optionLabel="fkName" optionValue="sid" appendTo="body" [showClear]="true"
        [(ngModel)]="foreignKey" class="form-control form-control-sm" placeholder="Select Foreign Key"
        [ngModelOptions]="{standalone: true,updateOn:'change'}" (ngModelChange)="handleforeignKeyChange($event)"
        [disabled]="disableField">
    </p-select>
    <p-select [showClear]="true" [options]="fieldsOptions" optionLabel="name" optionValue="sid" appendTo="body"
        [(ngModel)]="parentField" class="form-control form-control-sm ml-2" placeholder="Select Field"
        [ngModelOptions]="{standalone: true,updateOn:'change'}" (ngModelChange)="handleFieldChange($event)"
        [disabled]="disableField">
    </p-select>
</div>
<div class="d-flex justify-content-center align-items-center w-100" *ngIf="isLoading">
    <div class="spinner-container">
        <p-progress-spinner></p-progress-spinner>
    </div>
</div>